import * as React from 'react'

import {
  Button,
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader,
  DialogStateReturn,
  Paragraph,
  Textarea,
} from '../../../../components'

export function FeedbackDialog({
  state,
  doRating,
  stockWhyMovingHistoryId,
}: {
  state: DialogStateReturn
  stockWhyMovingHistoryId: number
  doRating: (stockWhyMovingHistoryId: number, liked: boolean, text?: string, skipFeedbackDialog?: boolean) => void
}) {
  const [feedback, setFeedback] = React.useState<string>('')
  const trimmedFeedback = React.useMemo(() => feedback.trim(), [feedback])

  const handleSubmit = React.useCallback(() => {
    window.gtag?.('event', 'click', {
      event_category: 'stocks-why-moving',
      event_label: 'feedback-dialog-submit',
    })
    doRating(stockWhyMovingHistoryId, false, feedback, true)
    state.hide()
  }, [state, doRating, stockWhyMovingHistoryId, feedback])

  return (
    <Dialog state={state} className="w-152" aria-label="Thank you for your feedback">
      <DialogHeader onCloseClick={state.hide} hasBorder={false}>
        Thank you for your feedback
      </DialogHeader>
      <DialogBody hasPadding={false} className="px-4">
        <Paragraph className="mb-1 text-muted font-normal">What didn’t you like about this summary?</Paragraph>
        <Textarea
          value={feedback}
          onChange={(e) => setFeedback((e.target as HTMLTextAreaElement).value)}
          rows={7}
          placeholder="Share details to help us improve…"
        />
        <DialogFooter className="py-3" padding={false}>
          <Button onClick={() => state.hide()} size="medium">
            Close
          </Button>
          <Button
            onClick={handleSubmit}
            theme="blue"
            size="medium"
            disabled={trimmedFeedback.length === 0}
            aria-label="Submit feedback"
          >
            Submit
          </Button>
        </DialogFooter>
      </DialogBody>
    </Dialog>
  )
}
